// extracted by mini-css-extract-plugin
export default {"detail_box":"Detail_detail_box__E7swl","back":"Detail_back__GCuPX","title":"Detail_title__zCYf+","time":"Detail_time__gOLan","contain":"Detail_contain__zR3qV"};